module.exports = __webpack_public_path__ + "img/dev-img.9f796846.png";